export const WIDGET_TYPE_VIDEO = 'video';
export const WIDGET_TYPE_IMAGE = 'image';
export const WIDGET_TYPE_BUTTON = 'button';
export const WIDGET_TYPE_ICON = 'icon';
export const WIDGET_TYPE_TEXT = 'text';
export const WIDGET_TYPE_HOTSPOT = 'hotspot';
export const WIDGET_TYPE_IFRAME = 'iframe';

export const CHANGE_SCENE_TYPES = {
	default: 'endOfScene',
	onclick: 'onClick',
};

export const WIDGET_TYPES = {
	WIDGET_TYPE_VIDEO,
	WIDGET_TYPE_IMAGE,
	WIDGET_TYPE_BUTTON,
	WIDGET_TYPE_ICON,
	WIDGET_TYPE_TEXT,
	WIDGET_TYPE_HOTSPOT,
	WIDGET_TYPE_IFRAME,
};

export const defaultIconPosition = 'left';
export const defaultIconSize = '20';
export const defaultIconSpacing = '20';

export const PLAYER_TRANSITIONS_IN = {
	none: 'none',
	fadeIn: 'fade-in',
};

export const PLAYER_TRANSITIONS_OUT = {
	none: 'none',
	fadeOut: 'fade-out',
};

const EVENT_INTERACT_VIEWED = 'qbrick_interact_viewed';
const EVENT_PAGE_VIEW = 'page_view';
const EVENT_SCENE_VIEWED = 'qbrick_scene_viewed';
const EVENT_WIDGET_CLICKED = 'qbrick_widget_clicked';

export const GA_INTERRACT_EVENTS = { EVENT_INTERACT_VIEWED, EVENT_PAGE_VIEW, EVENT_SCENE_VIEWED, EVENT_WIDGET_CLICKED };

const EVENT_MEDIA_LOADED = 'qplayer_loaded';
const EVENT_MEDIA_VIEWED = 'qplayer_viewed';
const EVENT_MEDIA_PLAYED = 'qplayer_played';
const EVENT_MEDIA_PAUSED = 'qplayer_paused';
const EVENT_MEDIA_COMPLETED = 'qplayer_completed';
const EVENT_MEDIA_HEARTBEAT = 'qplayer_heartbeat';

export const GA_MEDIA_EVENTS = {
	EVENT_MEDIA_LOADED,
	EVENT_MEDIA_VIEWED,
	EVENT_MEDIA_PLAYED,
	EVENT_MEDIA_PAUSED,
	EVENT_MEDIA_COMPLETED,
	EVENT_MEDIA_HEARTBEAT,
};
